import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=1ce5e1f8&scoped=true&"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5e1f8",
  null
  
)

export default component.exports